import { useMemo, useCallback } from 'react';
import { DressCodeFormValues } from './types';
import { AttireCategoryOption } from '../../../hooks/useAttireCategories';

export const useDressCodeAutoFill = (options: AttireCategoryOption[] = []) => {
  const dressCodeMap = useMemo(() => {
    const map: Record<string, { label: string; description: string }> = {};
    options.forEach(o => {
      map[o.value] = { label: o.label, description: o.description };
    });
    return map;
  }, [options]);

  const handleDressCodeTypeChange = useCallback(
    (
      raw: string | React.ChangeEvent<HTMLSelectElement>,
      values: DressCodeFormValues,
      form: any // Formik helpers
    ) => {
      const newValue = typeof raw === 'string' ? raw : raw?.currentTarget?.value || raw?.target?.value || '';
      if (newValue === values.attireCategoryId) return;

      const wasAutoTitle = options.some(o => o.label === values.title);

      // set attireCategoryId (no immediate validation)
      form.setFieldValue && form.setFieldValue('attireCategoryId', newValue, false);

      // auto-fill/clear title and validate title updates
      if (newValue && newValue !== 'other') {
        const matched = dressCodeMap[newValue];
        if (matched && (!values.title || wasAutoTitle)) {
          form.setFieldValue && form.setFieldValue('title', matched.label, true);
        }
      } else if (newValue === 'other' && wasAutoTitle) {
        form.setFieldValue && form.setFieldValue('title', '', true);
      }
      // mark touched and trigger validation next tick
      if (form.setFieldTouched) {
        setTimeout(() => {
          form.setFieldTouched('attireCategoryId', true, true);
        }, 0);
      }
    },
    [dressCodeMap, options]
  );

  return { handleDressCodeTypeChange };
};
